export async function generateAPMBanner(
  _apmData: unknown,
  _buildSku: string,
  buildId: string,
): Promise<void> {
  // The banner is served live by the Vercel API route /api/apm-banner?buildId=...
  // which reads APM data from Supabase and injects it into the template server-side.
  const bannerUrl = `${window.location.origin}/api/apm-banner?buildId=${buildId}`;
  const wrapperId = `aoi-apm-${buildId.slice(0, 8)}`;
  const embedCode = `<style>@media (min-width:769px){#${wrapperId}{max-width:968px !important;}}</style><div id="${wrapperId}" style="width:100%;margin:0 auto;"><iframe src="${bannerUrl}" style="width:100%;aspect-ratio:1199/595;border:0;display:block;" scrolling="no" loading="lazy"></iframe></div>`;
  await navigator.clipboard.writeText(embedCode);
}

export async function generateAPMBannerV2(
  _apmData: unknown,
  _buildSku: string,
  buildId: string,
): Promise<void> {
  // V2: same embed code but served by /api/apm-banner-v2 which uses a
  // Supabase-hosted background image instead of an inlined base64 PNG.
  const bannerUrl = `${window.location.origin}/api/apm-banner-v2?buildId=${buildId}`;
  const wrapperId = `aoi-apm-${buildId.slice(0, 8)}`;
  const embedCode = `<style>@media (min-width:769px){#${wrapperId}{max-width:968px !important;}}</style><div id="${wrapperId}" style="width:100%;margin:0 auto;"><iframe src="${bannerUrl}" style="width:100%;aspect-ratio:1199/595;border:0;display:block;" scrolling="no" loading="lazy"></iframe></div>`;
  await navigator.clipboard.writeText(embedCode);
}
